export default "__VITE_ASSET__B$rghYki__"